import React, { Fragment, useMemo } from 'react';
import { Form } from '../../../ui/universe';
import { Divider, Button, Tag } from 'tdesign-react';
import { transV2 } from '../../../../utils/index.js';
import { getSelectRectKey } from '../utils';

/**
 * SmartList 渲染器 - 智能结构化结果
 * @param {Object} props
 * @param {Object} props.params - OCR 响应参数
 * @param {Object} props.detail - 菜单详情配置
 * @param {string} props.selectRect - 当前选中的矩形 key
 * @param {Function} props.onSelect - 选中回调
 * @param {Object} props.request - 请求参数（包含 ItemNames）
 */
const SmartListRenderer = ({ params, detail, selectRect, onSelect, request }) => {
  const _params = transV2(params?.StructuralList);
  const showWordList = detail?.rectConfig?.useWordList && params?.WordList?.length > 0;

  // 从 request 的 ItemNames 构建 KeyName -> KeyExpectedValue 映射（GT 值不在 response 中）
  const gtValueMap = useMemo(() => {
    const map = {};
    const itemNames = request?.ItemNames || request?.requestParams?.ItemNames;
    if (Array.isArray(itemNames)) {
      itemNames.forEach((item) => {
        if (item.KeyExpectedValue) {
          map[item.KeyName] = item.KeyExpectedValue;
        }
      });
    }
    return map;
  }, [request]);

  return (
    <>
      {!detail?.showWordListOnly && (
        <>
          {_params?.list?.length > 0 && (
            <>
              {_params.list.map((item, index) => {
                const selectRectVal = getSelectRectKey({
                  data: item,
                  key: 'originItemCoord',
                  valStr: `${item.Name}${item.Value}`
                });
                const hasAudit = item.AuditResult !== undefined;
                const keyExpectedValue = item.KeyExpectedValue || gtValueMap[item.Name];
                return (
                  <Form.Item
                    key={`list-${index}`}
                    label={item.Name}
                    onClick={() => {
                      onSelect && onSelect(item.Value, selectRectVal);
                    }}
                    // className={`${selectRect && selectRect === selectRectVal ? 'isSelect' : ''} `}
                  >
                    <div>
                      <div>{item.Value}</div>
                      {hasAudit && (
                        <div style={{ marginTop: 4, fontSize: 12, display: 'flex', alignItems: 'center', gap: 6,color: item.AuditResult ? '#00a870' : '#e34d59' }}>
                          {keyExpectedValue !== undefined && <span style={{ color: '#999' }}>GT：{keyExpectedValue}</span>}
                          {item.AuditResult && <Tag theme="success" variant="light" size="small">通过</Tag> }
                          {keyExpectedValue !== undefined && !item.AuditResult && <Tag theme="danger" variant="light" size="small">不通过</Tag>}
                        </div>
                      )}
                    </div>
                  </Form.Item>
                );
              })}
            </>
          )}

          {_params.table.map((item, index) => (
            <Fragment key={`table-${index}`}>
              <p className="flex just-space-between align-center mtb-10">
                <Button variant="outline" theme="default">
                  <span>表格{index + 1}</span>
                </Button>
              </p>
              <div className="unv-table__container">
                <table style={{ minWidth: item.header.length * 100 }}>
                  <tbody>
                    <tr>
                      {item.header.map((header, hi) => (
                        <td key={`header-${hi}`} style={{ width: '100px' }}>{header}</td>
                      ))}
                    </tr>
                    {item.content.map((line, j) => (
                      <tr key={`row-${j}`}>
                        {line.map((tr, ti) => (
                          <td key={`cell-${ti}`} style={{ width: '100px' }}>{tr}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Fragment>
          ))}
        </>
      )}

      {showWordList && !detail?.showWordListOnly && (
        <Divider style={{ paddingRight: 20, color: '#4a70ff' }}>全文字段</Divider>
      )}

      {showWordList && params.WordList?.map((i, index) => {
        const selectRectVal = getSelectRectKey({
          data: i,
          key: 'Coord',
          valStr: i.DetectedText
        });
        return (
          <Form.Item
            className={`${selectRectVal && selectRect === selectRectVal ? 'isSelect' : ''} list`}
            key={`word-${index}`}
            label=""
            onClick={() => {
              onSelect && onSelect(i.DetectedText, selectRectVal);
            }}
          >
            {i.DetectedText}
          </Form.Item>
        );
      })}
    </>
  );
};

export default SmartListRenderer;
